import { createListenerGA, trackEvents } from "./ga";

const trackComponent = ({
  parentSelector,
  trackParentShow = false,
  parentShowEvent,
  trackChildrenClick = true,
  childrenSelector = ".js-track-event",
  childrenClickEvent,
  trackCategory = "component",
}) => {
  const currentUrl = window.location.href;
  const parentElement = document.querySelector(parentSelector);

  if (!parentElement) return;

  if (trackParentShow && parentShowEvent) trackEvents(trackCategory, parentShowEvent, currentUrl);

  if (trackChildrenClick) {
    const linksToTrack = parentElement.querySelectorAll(childrenSelector);
    linksToTrack.forEach((elem) => {
      createListenerGA(elem, "click", trackCategory, childrenClickEvent, currentUrl);
    });
  }
};

export { trackComponent };
